import {
  Typography,
  Link,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  MenuItem,
  Menu,
} from '@mui/material';
import React, { Component } from 'react';
import PortalModal from '../../../../common/PortalModal';
import Loader from '../../../../common/Loader';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { deleteData, getData, postData } from '../../../../../DataAccessLayer';
import { googleDrive } from '../../../../../DataAccessLayer/services';
import { FormButton } from '../../../../common/Form/FormButton';
import { Container, Row, Col } from 'reactstrap';
import { WithSmallScreen } from '../../../../common/WithSmallScreen';
import { getCourseMetadata } from '../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { isMeetingReadyToStart } from '../../utils';

class GoogleDrive extends Component {
  state = {
    drive: {},
    permissions: [],
    isDeleteModalOpen: false,
    isPermissionsModalOpen: false,
    isLoading: false,
    menuAnchor: null,
    isMenuOpen: false,
  };

  componentDidMount() {
    this.loadGoogleDrive();
  }

  handleToggleModal = (modal) => {
    this.setState({ [modal]: !this.state[modal] });
  };

  //Θ(1)
  loadGoogleDrive = async () => {
    const { termCode, crn } = getCourseMetadata(this.props.course);

    this.setState({ isLoading: true });
    try {
      const data = await getData(
        googleDrive.load({
          crn,
          termCode,
        }),
        true,
      );

      this.setState({ drive: data });
    } catch (err) {
      console.log(err);
      this.setState({ drive: {} });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  //Θ(1)
  createSharedDrive = async () => {
    const { termCode, crn, subjectCode, courseNumber, courseTitle } = getCourseMetadata(
      this.props.course,
    );

    const body = {
      crn,
      termCode,
      driveName: `${termCode}_${subjectCode}_${courseNumber}_${courseTitle}`,
    };

    this.setState({ isLoading: true });
    try {
      await postData(googleDrive.create, body, true);
      toast.success('Google drive created!');
    } catch (err) {
      console.log('Google drive creation error:', err);
      if (err?.timeout || err?.data?.timeout) {
        // true if API gateway API call returns 504 response code because Lambda is running for too long.
        toast.error('Drive creation pending. Please check back in 15 minutes.');
      } else {
        toast.error('Error creating drive.');
      }
    } finally {
      this.setState({ isLoading: false });
      this.loadGoogleDrive();
    }
  };

  //Θ(1)
  deleteSharedDrive = async () => {
    const { termCode, crn } = getCourseMetadata(this.props.course);

    this.setState({ isLoading: true });
    try {
      await deleteData(
        googleDrive.delete({
          crn,
          termCode,
        }),
        {},
        true,
      );
      toast.success('Google drive deleted.');
    } catch (err) {
      toast.error('Error deleting Google drive.');
    } finally {
      this.setState({ isLoading: false });
      this.handleToggleModal('isDeleteModalOpen');
      this.loadGoogleDrive();
    }
  };

  openPermissionsModal = async () => {
    this.handleToggleModal('isPermissionsModalOpen');
    const { termCode, crn } = getCourseMetadata(this.props.course);
    this.setState({ isLoading: true });
    try {
      const data = await getData(
        googleDrive.getPermissions({
          crn,
          termCode,
        }),
        true,
      );
      this.setState({ permissions: data });
    } catch (err) {
      console.log(err);
      this.setState({ permissions: [] });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  syncDrivePermissions = async () => {
    const { termCode, crn } = getCourseMetadata(this.props.course);
    this.setState({ isLoading: true });
    try {
      await postData(
        googleDrive.syncPermissions({
          crn,
          termCode,
        }),
        {},
        true,
      );
      toast.success('Google drive permissions synchronized.');
    } catch (err) {
      toast.error('Error synchronizing Google drive permissions.');
    } finally {
      this.setState({ isLoading: false });
      this.handleToggleModal('isPermissionsModalOpen');
    }
  };

  dropAnchor = (e) => {
    this.setState({ menuAnchor: e.currentTarget, isMenuOpen: true });
  };

  pullAnchor = () => {
    this.setState({ menuAnchor: null, isMenuOpen: false });
  };

  render() {
    const { isLoading, isDeleteModalOpen, isPermissionsModalOpen, drive, permissions } = this.state;

    const { course } = this.props;

    const isTeaching = course.isTeaching;

    return (
      <React.Fragment>
        <Container className="p-3">
          <Loader isOpen={isLoading} />
          <Typography variant="h3">Google Drive</Typography>
          <Row className={`justify-content-center align-items-center flex-row`}>
            <Col
              xs="12"
              sm="6"
              md="6"
              lg="3"
              className={`d-flex justify-content-center align-items-center`}
            >
              <img
                src={!drive.URL ? '/img/cct_googleDriveSearch.svg' : '/img/cct_googleDrive.svg'}
                alt=""
                style={{ height: 'auto', margin: '0.5rem' }}
              />
            </Col>
          </Row>
          {isTeaching && (
            <Row className={`justify-content-center align-items-center flex-row`}>
              <Col
                xs="12"
                sm="10"
                md="8"
                lg="5"
                className={`d-flex align-items-center text-center`}
              >
                <Typography>
                  Use Google Drive to create, access, and collaborate on documents, spreadsheets,
                  presentations, and more for this course from anywhere on any device.
                </Typography>
              </Col>
            </Row>
          )}

          {!drive.URL ? (
            <>
              <Row className="justify-content-center align-items-center flex-row">
                <Col className="text-center p-2">
                  <Typography component="p" sx={{ mt: 1 }}>
                    There is no Google Drive for this class.{' '}
                  </Typography>
                </Col>
              </Row>
              <Row className="justify-content-center align-items-center flex-row">
                <Col className="text-center p-2">
                  <Typography component="p" sx={{ my: 0 }}>
                    {isTeaching && (
                      <Button
                        className="myOdu__button"
                        variant="outlined"
                        onClick={this.createSharedDrive}
                        size="small"
                        style={{ margin: '0rem' }}
                      >
                        Create a Google Drive
                      </Button>
                      // Now a button instead of a link for keyboard navigability
                      // <Link sx={{ cursor: 'pointer' }} onClick={this.createSharedDrive}>
                      //   Create a Google Drive
                      // </Link>
                    )}
                  </Typography>
                </Col>
              </Row>
            </>
          ) : (
            <Row className="justify-content-center align-items-center flex-row">
              {/* new menu instead of buttons/links */}
              <Col xs="12" sm="6" md="4" lg="3" className="text-center">
                {isTeaching ? (
                  <>
                    <Button
                      className="myOdu__button cctActions"
                      aria-haspopup
                      aria-expanded={this.state.isMenuOpen}
                      variant="outlined"
                      endIcon={
                        <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: '.8rem' }} />
                      }
                      onClick={this.dropAnchor}
                      size="small"
                      sx={{ mt: '0.5rem' }}
                      fullWidth
                    >
                      Actions
                    </Button>
                    <Menu
                      anchorEl={this.state.menuAnchor}
                      open={this.state.isMenuOpen}
                      onClose={this.pullAnchor}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <MenuItem
                        disabled={!drive.URL}
                        onClick={() => {
                          window.open(drive.URL, '_blank', 'noreferrer');
                          this.pullAnchor();
                        }}
                        id={'cct__menuItem_launchDrive'}
                      >
                        Launch Google Drive
                      </MenuItem>
                      {isTeaching && (
                        <>
                          <MenuItem
                            onClick={() => {
                              this.openPermissionsModal();
                              this.pullAnchor();
                            }}
                            id={'cct__menuItem_drivePermissions'}
                          >
                            Review Google Drive Permissions
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              this.handleToggleModal('isDeleteModalOpen');
                              this.pullAnchor();
                            }}
                            id={'cct__menuItem_deleteDrive'}
                          >
                            Delete Google Drive
                          </MenuItem>
                        </>
                      )}
                    </Menu>
                  </>
                ) : (
                  <Button
                    className="myOdu__button"
                    variant="outlined"
                    onClick={() => window.open(drive.URL, '_blank', 'noreferrer')}
                    size="small"
                    sx={{ mt: '0.5rem' }}
                    fullWidth
                  >
                    Launch Google Drive
                  </Button>
                )}
              </Col>
            </Row>
          )}
        </Container>

        <PortalModal
          maxWidth="sm"
          onClose={() => this.handleToggleModal('isDeleteModalOpen')}
          onPrimaryClick={this.deleteSharedDrive}
          onSecondaryClick={() => this.handleToggleModal('isDeleteModalOpen')}
          isOpen={isDeleteModalOpen}
          title="Delete Google Drive"
          id="deleteGoogleDriveModal"
          primaryButtonTitle="Yes"
          secondaryButtonTitle="No, Cancel"
        >
          <Loader isOpen={isLoading} />
          <Typography>Are you sure you want to delete this drive?</Typography>
        </PortalModal>

        <PortalModal
          maxWidth="md"
          isCloseable={true}
          onClose={() => this.handleToggleModal('isPermissionsModalOpen')}
          onPrimaryClick={this.syncDrivePermissions}
          isOpen={isPermissionsModalOpen}
          title="Google Drive Permissions"
          id="googleDrivePermissionsModal"
          primaryButtonTitle="Sync Drive Permissions"
        >
          <Loader isOpen={isLoading} />
          {isLoading ? (
            <Typography>Loading...</Typography>
          ) : (
            <>
              <Typography>
                Use the button to sync Google Drive permissions with Banner registration data. You
                may also manage permissions directly in Google Drive.
              </Typography>
              <Table>
                <caption className="sr-only">
                  Table of users and assigned roles with access to this course's Google Drive
                </caption>
                <TableHead sx={{ fontWeight: 'heavy' }}>
                  <TableRow>
                    <TableCell>Email Address</TableCell>
                    <TableCell>Role</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {permissions?.length ? (
                    permissions.map((row) => (
                      <TableRow>
                        <TableCell>{row.emailAddress}</TableCell>
                        <TableCell>{row.role}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={2}>No data found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </>
          )}
        </PortalModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    course: state.CCTReducer.course,
  };
};

export default connect(mapStateToProps)(WithSmallScreen(GoogleDrive));
